/* ----- Input.js ----- */
import React, { useState } from "react";
import "./InputStyles.scss";

// Libraries & Packages
import { useThemeStore } from "utils/state/Store";

// Utils
import {
  setInputBoxBorderStyles,
  setInputBoxColorStyles,
  setInputBoxFontStyles,
  setInputBoxSizeStyles,
  setInputBoxSpacingStyles,
  setInputContainerDisplayStyles,
  setInputContainerSizeStyles,
  setInputLabelColorStyles,
  setInputLabelDisplayStyles,
  setInputLabelFontStyles,
  setInputLabelSizeStyles,
} from "./InputUtils";

function Input({
  borderRadius = "xs",
  label,
  name,
  onChange,
  placeholder,
  size,
  value,
  width = "200px",
}) {
  // State
  const { theme } = useThemeStore();
  const [isFocused, setIsFocused] = useState(false);

  // Input Container Styles
  var stylesInputContainer = {
    // Display
    ...setInputContainerDisplayStyles(),

    // Size
    width: setInputContainerSizeStyles(width).width,
  };

  // Input Box Styles
  var stylesInputBox = {
    // Border
    border: setInputBoxBorderStyles(borderRadius).border,
    borderStyle: setInputBoxBorderStyles(borderRadius).borderStyle,
    borderWidth: setInputBoxBorderStyles(borderRadius).borderWidth,
    borderRadius: setInputBoxBorderStyles(borderRadius).borderRadius,
    borderColor: setInputBoxColorStyles(isFocused, theme).borderColor,

    // Color
    color: setInputBoxColorStyles(isFocused, theme).color,

    // Size
    height: setInputBoxSizeStyles(size).height,
    // width: setInputBoxSizeStyles(size).width,

    // Spacing
    padding: setInputBoxSpacingStyles(size).padding,

    // Font
    fontSize: setInputBoxFontStyles(size).fontSize,
    fontFamily: "Argesta-Display",
  };

  // Input Label Styles
  var stylesLabel = {
    //  Color
    color: setInputLabelColorStyles(theme).color,

    // Size
    height: setInputLabelSizeStyles(size).height,
    width: setInputLabelSizeStyles(size).width,

    // Font
    fontSize: setInputLabelFontStyles(size).fontSize,
    fontWeight: setInputLabelFontStyles().fontWeight,
    fontFamily: "Ginqail",

    // Display
    ...setInputLabelDisplayStyles(label),
  };

  return (
    <div className="wso2__ob__ui__inputText" style={stylesInputContainer}>
      <div style={stylesLabel}>{label}</div>
      <input
        type="text"
        name={name}
        placeholder={placeholder}
        style={stylesInputBox}
        onChange={onChange && onChange}
        onFocus={() => {
          setIsFocused(!isFocused);
        }}
        onBlur={() => {
          setIsFocused(!isFocused);
        }}
        value={value}
      />
    </div>
  );
}

export default Input;
